document.addEventListener("DOMContentLoaded", () => {
  const siteMain = document.querySelector('.site-main');
  if(siteMain){
    setMainPaddingBottom();
    window.addEventListener("resize", setMainPaddingBottom);
    window.addEventListener("orientationchange", setMainPaddingBottom);
  }
});
function setMainPaddingBottom() {
  let footer = document.querySelector(".site-footer");
  let main = document.querySelector(".site-main");
  let footerHeight = footer.offsetHeight;

  main.style.paddingBottom = footerHeight + "px";
  main.style.marginBottom = "-" + footerHeight + "px";
}
